import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { CopyOutlined } from "@ant-design/icons";
import ControlButton from "../base-button";

interface IProps {
  showLabel?: boolean;
  showTooltip?: boolean;
  className?: string;
  tooltipColor?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const DuplicateButton = ({
  showLabel = false,
  showTooltip = true,
  className = "",
  tooltipColor,
  onClick,
}: IProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <ControlButton
      className={className}
      showLabel={showLabel}
      showTooltip={showTooltip}
      label={t("Duplicate")}
      tooltipColor={tooltipColor}
      data-testid="duplicate-button"
      onClick={onClick}
    >
      <CopyOutlined />
    </ControlButton>
  );
};

export default DuplicateButton;
